import { lazy } from 'react';

import { closeDialog, openDialog } from '@/dialogs/actions';

const UserDeleteDialog = lazy(() => import('./UserDelete'));
const UserEditorDialog = lazy(() => import('./UserEditor'));
const UserApproveDialog = lazy(() => import('./UserApprove'));
const UserImportDialog = lazy(() => import('./UserImport'));
const UnarchiveAdminRoleChangerDialog = lazy(() => import('./UnarchiveAdminRoleChangerDialog'));

// Identifiers for each dialog
export const USER_DELETE_DIALOG = 'USER_DELETE_DIALOG';
export const USER_EDIT_DIALOG = 'USER_EDIT_DIALOG';
export const USER_MERGE_DIALOG = 'USER_MERGE_DIALOG';
export const USER_IMPORT_DIALOG = 'USER_IMPORT_DIALOG';
export const USER_TERMINATION_DIALOG = 'USER_TERMINATION_DIALOG';
export const UNARCHIVE_ADMIN_ROLE_CHANGER_DIALOG = 'UNARCHIVE_ADMIN_ROLE_CHANGER_DIALOG';

// Actions for opening dialogs
export const openUserDeleteDialog = openDialog.bind(null, USER_DELETE_DIALOG);
export const closeUserDeleteDialog = closeDialog.bind(null, USER_DELETE_DIALOG);
export const openUserEditDialog = openDialog.bind(null, USER_EDIT_DIALOG);

export default {
  [USER_DELETE_DIALOG]: UserDeleteDialog,
  [USER_EDIT_DIALOG]: UserEditorDialog,
  [USER_MERGE_DIALOG]: UserApproveDialog,
  [USER_IMPORT_DIALOG]: UserImportDialog,
  [UNARCHIVE_ADMIN_ROLE_CHANGER_DIALOG]: UnarchiveAdminRoleChangerDialog,
};
